import * as R from 'ramda';
import styled from 'styled-components';
import {
  width,
  space,
  color,
  border,
  layout,
  shadow,
  system,
  height,
  flexbox,
  position,
  minWidth,
  background,
  typography,
  borderRadius,
} from 'styled-system';
// ui
import { Button } from './elements';
//////////////////////////////////////////////////

const ContentBox = styled.div`
  width: 100%;
  padding-top: 54px;
  min-height: calc(100vh - 150px);
  background-color: ${({ theme }) => theme.background.page};
`;

const PageWrapperBox = styled.main`
  width: 100%;
  height: 100%;
  padding: 24px 32px;
`;

const Box = styled.div`
  ${space}
  ${width}
  ${color}
  ${border}
  ${layout}
  ${shadow}
  ${flexbox}
  ${position}
  ${background}
  ${typography}

  cursor: ${({ cursor }) => cursor};
  z-index: ${({ zIndex }) => zIndex};
  opacity: ${({ opacity }) => opacity}
  transform: ${({ transform }) => transform};
  animation: ${({ animation }) => animation};
  word-break: ${({ wordBreak }) => wordBreak};
  transition: ${({ transition }) => transition};
  visibility: ${({ visibility }) => visibility};
  white-space: ${({ whiteSpace }) => whiteSpace};
  user-select: ${({ userSelect }) => userSelect};
  vertical-align: ${({ verticalAlign }) => verticalAlign};
  text-transform: ${({ textTransform }) => textTransform};
  text-decoration: ${({ textDecoration }) => textDecoration};

  &:hover {
    opacity: ${({ hoveredOpacity }) => hoveredOpacity};
  }
`;

const gap = system({
  gap: {
    property: 'gap',
    transform: value => {
      if (R.includes('px', value)) return value;

      return `${value}px`;
    },
  },
});

const Flex = styled(Box)`
  ${gap}
`;

Flex.defaultProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'normal',
};

const RelativeBox = styled(Box)`
  position: relative;
`;

const RelativeFlex = styled(Flex)`
  position: relative;
`;

const AbsoluteBox = styled(Flex)`
  position: absolute;
`;

const StickedBox = styled(Box)`
  position: sticky;
`;

const StickedFlex = styled(Flex)`
  position: sticky;
`;

const FixedBox = styled(Box)`
  position: fixed;
`;

const FixedFlex = styled(Flex)`
  position: fixed;
`;

const IconWrapper = styled.div`
  ${space}
  ${width}
  ${height}

  user-select: none;
  transition: transform 0.3s ease-in-out;
  cursor: ${({ cursor }) => cursor || 'default'};

  &:hover {
    opacity: ${({ hoveredOpacity }) => hoveredOpacity || 1};
    transform: ${({ hoveredTransform }) => hoveredTransform || 'scale(1)'};
  }
`;

const Divider = ({ my, text, theme }) => (
  <Flex my={my || '5px'}>
    <Box height='1px' flexGrow='1' bg={theme.colors.middleGrey} />
    <Box px='5px' fontSize={14} color={theme.colors.darkGrey}>{text}</Box>
    <Box height='1px' flexGrow='1' bg={theme.colors.middleGrey} />
  </Flex>
);

const InstanceButton = styled(Button)`
  ${minWidth}
  ${borderRadius}

  display: ${({ display }) => display};
  border: ${({ border }) => border || 'none'};
  z-index: ${({ zIndex }) => zIndex || 'unset'};
  background: ${({ background }) => background};
  font-weight: ${({ fontWeight }) => fontWeight};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  text-transform: ${({ textTransform }) => textTransform};
`;

InstanceButton.defaultProps = {
  height: 40,
  minWidth: 100,
  borderRadius: '2px',
};

const CancelButton = styled(InstanceButton)`
  color: ${({ theme, textColor }) => textColor || theme.colors.lightBlack};
  background-color: ${({ theme, bgColor }) => bgColor || theme.colors.lightGrey};
`;

const ActionButton = styled(InstanceButton)`
  border-color: ${({ borderColor }) => borderColor};
  background-color: ${({ theme, bgColor }) => bgColor || theme.colors.lime};
  color: ${({ theme, textColor }) => textColor || theme.colors.lightBlack};
`;

export {
  Box,
  gap,
  Flex,
  Divider,
  FixedBox,
  FixedFlex,
  ContentBox,
  StickedBox,
  IconWrapper,
  AbsoluteBox,
  StickedFlex,
  RelativeBox,
  ActionButton,
  RelativeFlex,
  CancelButton,
  InstanceButton,
  PageWrapperBox,
};
